/**
 * Converts an axios error to an actionResponse (our notification object)
 * @param action - the action holding the type, data & error returned by axios
 * @returns {{type: action type, status: status from backend, axiosError: *}}
 */
export function convertAxiosError(action) {
  let status;
  if (action.error.response.data.status) {
    status = {
      code: action.error.response.data.status.code,
      message: action.error.response.data.status.message,
    };
  }
  const actionResponse = {
    type: action.type,
    status: status,
    axiosError: {
      status: action.error.response.status,
      statusText: action.error.response.statusText,
    },
  };

  return actionResponse;
}

/**
 * Converts an axios data status object to an actionResponse (our notification object)
 * @param action - the action holding the type, data & error returned by axios
 * @returns {{type: *, status: *}}
 */
export function convertAxiosSuccess(action) {
  let status;
  if (action.payload.status) {
    status = {
      code: action.payload.status.code,
      message: action.payload.status.message,
    };
  }
  const actionResponse = {
    type: action.type,
    status: status,
  };
  return actionResponse;
}
